import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="page-404">
      <div>
        <div className="badge warn">404</div>
        <h1>Signal lost</h1>
        <p className="muted" style={{ maxWidth: 420, margin: '0.75rem auto 1.25rem' }}>
          That route is not on the Atlas map. The verification pulse continues on the live surfaces below.
        </p>
        <div className="hero-actions" style={{ justifyContent: 'center' }}>
          <Link to="/" className="btn btn-primary">
            Marketing home
          </Link>
          <Link to="/dashboard" className="btn btn-secondary">
            Demo tracker
          </Link>
        </div>
      </div>
    </div>
  )
}
